// @ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import { downloadMyActionCardDocument, fetchMyActionCardDocuments } from '../../services/api';

export default function ActionCards() {
  const [studentId, setStudentId] = useState<any>(null);
  const [documents, setDocuments] = useState<any>([]);
  const [loading, setLoading] = useState<any>(true);
  const [busyDocumentId, setBusyDocumentId] = useState<any>(null);
  const [error, setError] = useState<any>('');

  useEffect(() => {
    let cancelled = false;
    fetchMyActionCardDocuments()
      .then((result) => {
        if (cancelled) return;
        setStudentId(result.student_id);
        setDocuments(Array.isArray(result.documents) ? result.documents : []);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Could not load your school activity resources.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const groups = useMemo(() => documents.reduce((byStandard, document) => {
    const code = document.standard_code || 'Other resources';
    byStandard[code] = [...(byStandard[code] || []), document];
    return byStandard;
  }, {}), [documents]);

  const handleDownload = async (document) => {
    setBusyDocumentId(document.document_id);
    setError('');
    try {
      const blob = await downloadMyActionCardDocument(document.document_id);
      const url = URL.createObjectURL(blob);
      const link = window.document.createElement('a');
      link.href = url;
      link.download = document.filename;
      link.rel = 'noopener noreferrer';
      window.document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err: any) {
      setError(err.message || 'Could not download school activity resource.');
    } finally {
      setBusyDocumentId(null);
    }
  };

  return (
    <main style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
      <header style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, color: '#1e3a8a', fontSize: 28 }}>Action Card Resources</h1>
        <p style={{ margin: '8px 0 0', color: '#475569', lineHeight: 1.5 }}>
          Activity documents shared by your school for the learning standards you are working on.
        </p>
      </header>
      {error && <div role="alert" style={{ marginBottom: 14, color: '#991b1b' }}>{error}</div>}
      {loading ? (
        <div role="status">Loading school activity resources…</div>
      ) : Object.keys(groups).length === 0 ? (
        <section style={{ padding: 20, border: '1px solid #dbe4f0', borderRadius: 12, background: '#fff', color: '#64748b' }}>
          Your teachers have not shared any school activity documents yet.
        </section>
      ) : (
        <div style={{ display: 'grid', gap: 14 }}>
          {Object.entries(groups).map(([standardCode, items]) => (
            <section key={standardCode} aria-label={`Resources for ${standardCode}`}
              style={{ padding: 18, border: '1px solid #dbe4f0', borderRadius: 12, background: '#fff', boxShadow: '0 5px 16px rgba(15, 23, 42, 0.05)' }}>
              <h2 style={{ margin: '0 0 10px', color: '#1e3a5f', fontSize: 16 }}>{standardCode}</h2>
              <ul style={{ display: 'grid', gap: 8, listStyle: 'none', padding: 0, margin: 0 }}>
                {items.map((document) => (
                  <li key={document.document_id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, padding: 10, border: '1px solid #dbe4f0', borderRadius: 8, background: '#f8fafc' }}>
                    <div style={{ minWidth: 0, overflowWrap: 'anywhere' }}>
                      <div style={{ fontWeight: 700, color: '#334155' }}>{document.filename}</div>
                      <div style={{ marginTop: 3, color: '#64748b', fontSize: 11 }}>
                        {Math.max(1, Math.ceil(document.file_size_bytes / 1024))} KB
                      </div>
                    </div>
                    <button type="button" disabled={!studentId || busyDocumentId !== null}
                      onClick={() => handleDownload(document)}
                      style={{ flex: '0 0 auto', padding: '8px 12px', border: 0, borderRadius: 7, background: '#1d4ed8', color: '#fff', fontWeight: 700, cursor: busyDocumentId !== null ? 'wait' : 'pointer' }}>
                      {busyDocumentId === document.document_id ? 'Downloading…' : 'Download'}
                    </button>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      )}
    </main>
  );
}